module.exports = __webpack_public_path__ + "img/copy-icon.85d4425c.svg";